export default __webpack_public_path__ + "static/media/10t.57045280.jpg";